/** Messages per list page (the platform API allows up to 200). */
export const PAGE_SIZE = 50;

/** The source viewer loads at most this much (the .eml download has the whole message). */
export const SOURCE_VIEW_BYTES = 2 * 1024 * 1024;
